<!--
  - @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
  -
  - @author Ferdinand Thiessen <opensource@fthiessen.de>
  -
  - @license AGPL-3.0-or-later
  -
  - This program is free software: you can redistribute it and/or modify
  - it under the terms of the GNU Affero General Public License as
  - published by the Free Software Foundation, either version 3 of the
  - License, or (at your option) any later version.
  -
  - This program is distributed in the hope that it will be useful,
  - but WITHOUT ANY WARRANTY; without even the implied warranty of
  - MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  - GNU Affero General Public License for more details.
  -
  - You should have received a copy of the GNU Affero General Public License
  - along with this program. If not, see <http://www.gnu.org/licenses/>.
  -
  -->
<template>
	<li ref="activityMount" />
</template>

<script setup lang="ts">
import type { IActivitySidebarEntry } from '../../models/ActivityAPI'
import { getCurrentInstance, onMounted, onUnmounted, ref } from 'vue'

const props = defineProps<{
	activity: IActivitySidebarEntry
	showPreviews: boolean
}>()

const emit = defineEmits<{
	(e: 'reload'): void
}>()

const activityMount = ref<HTMLLIElement>()

onMounted(() => props.activity.mount(activityMount.value as HTMLLIElement, { context: getCurrentInstance()?.proxy, reload: () => emit('reload') }))
onUnmounted(() => props.activity.unmount())
</script>
